// extracted by mini-css-extract-plugin
export const basic_button = "basic-button-module--basic_button--3GmgL";
export const basic_button_link = "basic-button-module--basic_button_link--1u770";